import { useState } from "react";
import { toast } from "sonner";
import axios from "../axios";

export const useGetGameById = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const getGameById = async (token, id) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/game/${id}/show-game`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setLoading(false);
        setData(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
    }
  };

  return {
    getGameById,
    data,
    setData,
    loading,
    setLoading,
  };
};
